module.exports = __webpack_public_path__ + "img/admin.30aa0d01.svg";